var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 4.0002C22.8164 4.00411 22.6562 4.02364 22.5 4.0627L6.25 8.34395C4.9375 8.6877 4 9.89083 4 11.2502V25.0002C4 26.6447 5.35547 28.0002 7 28.0002H25C26.6445 28.0002 28 26.6447 28 25.0002V12.0002C28 10.3557 26.6445 9.0002 25 9.0002H11.625L23 6.0002V8.0002H25V6.0002C25 4.8752 24.043 3.98458 22.9688 4.0002ZM7 11.0002H25C25.5664 11.0002 26 11.4338 26 12.0002V25.0002C26 25.5666 25.5664 26.0002 25 26.0002H7C6.43359 26.0002 6 25.5666 6 25.0002V12.0002C6 11.4338 6.43359 11.0002 7 11.0002ZM22.5 17.0002C21.6719 17.0002 21 17.6721 21 18.5002C21 19.3283 21.6719 20.0002 22.5 20.0002C23.3281 20.0002 24 19.3283 24 18.5002C24 17.6721 23.3281 17.0002 22.5 17.0002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.8b821bb015ba0c09412ca33b811abf27.svg";
export { ForwardRef as ReactComponent };